import { Component } from '@angular/core';

@Component({
    selector: 'app-if-section',
    templateUrl: './if-section.component.html',
    styleUrl: './if-section.component.scss',
    standalone: false
})
export class IfSectionComponent {

}
